import { useCallback, useState } from 'react';

import { FCWithChildren } from 'common/types';

import { ModalContext } from './hooks';

const ModalProvider: FCWithChildren = ({ children }) => {
  const [modalType, setModalType] = useState<string | null>(null);

  const showModal = (type: string) => setModalType(type);
  const hideModal = useCallback(() => setModalType(null), []);
  const isModalOpen = useCallback(
    (modalTypeToCheck: string) => modalType === modalTypeToCheck,
    [modalType],
  );

  return (
    <ModalContext.Provider value={{ hideModal, isModalOpen, showModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
